import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { showMessage } from '@lib/actions';
import axiosClient from '@lib/utils/axiosClient';

import { PatientForm } from '../types';

type Data = Partial<PatientForm>;
type Response = PatientForm;

const mutationFn = async (data: Data) => {
  const response = await axiosClient.put(`/patientForms/${data._id}`, data);
  return response.data as Response;
};

export default function usePatientFormUpdateById() {
  const dispatch = useDispatch();

  const mutation = useMutation(mutationFn, {
    // TODO: Make errors management generic to all `react-query` mutations
    onError: (error: Error) => {
      dispatch(showMessage(error.message, 'error'));
    },
  });

  return mutation;
}
